// import { MyApiClient } from '../myjs/my-api-client.js'
// import Swal from 'sweetalert2'

// ================================
// Created : 11.01.2566 use in..
// - MPatients.vue
// ================================
export default {
  upperCase (str) {
    const tStr = typeof str
    // console.log(tStr)
    if (tStr === 'string') {
      return str.toUpperCase()
    } else {
      return ''
    }
  },
  lowerCase (str) {
    const tStr = typeof str
    // console.log(tStr)
    if (tStr === 'string') {
      return str.toLowerCase()
    } else {
      return ''
    }
  },

  // แปลงรูปแบบการแสดงผลแล็บ ถ้าเป็นตัวเลขใส่คอมม่าและทศนิมยม ถ้าไม่ใช่แสดงค่าเดิม
  FormatNumResult (row) {
    if (this.isNumber(row.Result) && (row.Result.trim() !== '')) {
      let NumStr = ''
      NumStr = row.Result.replace(/[,]/g, '') // ตัด , ออกไปก่อน (ถ้ามี) -> ex. 456789.567
      NumStr = Number(NumStr).toFixed(row.Decimals) // ปรับจำนวนทศนิยม
      var A = NumStr.toString().split('.')[0] // จำนวนหน้า .
      var B = NumStr.toString().split('.')[1] // ทศนิยมหลัง .
      if (typeof A === 'undefined') { A = '' }
      if (typeof B === 'undefined') { B = '' }
      if (row.Decimals > 0) { B = '.' + B }
      // console.log(A.replace(/\B(?=(\d{3})+(?!\d))/g, ',').trim() + '.' + B)
      return A.replace(/\B(?=(\d{3})+(?!\d))/g, ',').trim() + B
    } else {
      return row.Result
    }
  },
  // ตรวจสอบว่าเป็นตัวเลขหรือไม่
  isNumber (val) {
    let NumStr = ''
    if (typeof val === 'undefined') { val = '' }
    NumStr = val.replace(/[,]/g, '') // ตัด , ออกไปก่อน
    return !isNaN(NumStr)
  },

  // Check date format : YYYY-MM-DD
  // isValidDate (dateString) {
  // var regEx = /^\d{4}-\d{2}-\d{2}$/
  //   return dateString.match(regEx) != null
  // },

  // Check date format : YYYY-MM-DD และตรวจสอบ 29FEB ได้
  isValidDate (dateIn) {
    // Date format: YYYY-MM-DD
    var datePattern = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/

    // Check if the date string format is a match
    var matchArray = dateIn.match(datePattern)
    if (matchArray == null) {
      return false
    }

    // Remove any non digit characters
    var dateString = dateIn.replace(/\D/g, '')

    // Parse integer values from the date string
    var year = parseInt(dateString.substr(0, 4))
    var month = parseInt(dateString.substr(4, 2))
    var day = parseInt(dateString.substr(6, 2))

    // Define the number of days per month
    var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

    // Leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      daysInMonth[1] = 29
    }

    if (month < 1 || month > 12 || day < 1 || day > daysInMonth[month - 1]) {
      return false
    }
    return true
  },

  convertDMY2YMD (dateString) {
    // split date string at '/'
    var dateArr = dateString.split('-')

    // test results of split
    // console.log(dateArr[0])
    // console.log(dateArr[1])
    // console.log(dateArr[2])

    if (dateArr.length === 3) {
      // check for single number day or month
      // prepend '0' to single number dar or month
      if (dateArr[0].length === 1) {
        dateArr[0] = '0' + dateArr[0]
      } else if (dateArr[1].length === 1) {
        dateArr[1] = '0' + dateArr[1]
      }
      // create date obj from string
      return new Date(dateArr[2] + '-' + dateArr[1] + '-' + dateArr[0])
    } else {
      return null
    }
  },

  // ตรวจสอบว่าเป็น พ.ศ. หรือไม่?
  isBEBirthDate (DOB) {
    const dToday = new Date()
    const nTodayYYYY = dToday.getFullYear()
    if (DOB.getUTCFullYear() > nTodayYYYY) {
      // ปีเกิด มากกว่า ค.ศ. ปัจจุบัน --> ประเมินว่าป้อนมาเป็นปี พ.ศ.
      return true
    }
    return false
  },

  // แปลงวันที่ พ.ศ. เป็น ค.ศ.
  DateBE2AD (DOB) {
    const nYYYY = DOB.getUTCFullYear() - 543
    let nMM = DOB.getMonth() + 1 // 0=JAN 1=FEB .. 11=DEC
    nMM = ('0' + nMM).slice(-2) // 1-9 -> '01'..'09'
    let nDD = DOB.getDate()
    nDD = ('0' + nDD).slice(-2) // 1-9 -> '01'..'09'
    // วันที่ ค.ศ.
    const DateAD = new Date(nYYYY + '-' + nMM + '-' + nDD)

    return DateAD
  },
  DateAD2AD (DOB) {
    const nYYYY = DOB.getUTCFullYear()
    let nMM = DOB.getMonth() + 1 // 0=JAN 1=FEB .. 11=DEC
    nMM = ('0' + nMM).slice(-2) // 1-9 -> '01'..'09'
    let nDD = DOB.getDate()
    nDD = ('0' + nDD).slice(-2) // 1-9 -> '01'..'09'
    // วันที่ ค.ศ.
    const DateAD = new Date(nYYYY + '-' + nMM + '-' + nDD)

    return DateAD
  },
  calculateAge (DOB) {
    var userDateinput = DOB
    // ตรวจสอบวันเกิด : ถ้าไม่มีค่า อายุเท่ากับ 0 ปี
    if (typeof userDateinput === 'undefined' || userDateinput === null) {
      return 0
    }
    // ตรวจสอบวันเกิด : ถ้าป้อนเป็น พ.ศ. ให้แปลงเป็น ค.ศ. ก่อน
    const dToday = new Date()
    const nTodayYYYY = dToday.getFullYear()
    if (userDateinput.getUTCFullYear() > nTodayYYYY) {
      // ปีเกิด มากกว่า ค.ศ. ปัจจุบัน --> ประเมินว่าป้อนมาเป็นปี พ.ศ.
      //  ให้แปลงเป็น ค.ศ. โดยลบ 543 ปี
      const nYYYY = userDateinput.getUTCFullYear() - 543
      let nMM = userDateinput.getMonth() + 1 // 0=JAN 1=FEB .. 11=DEC
      nMM = ('0' + nMM).slice(-2) // 1-9 -> '01'..'09'
      let nDD = userDateinput.getDate()
      nDD = ('0' + nDD).slice(-2) // 1-9 -> '01'..'09'
      // console.log(nYYYY + '-' + nMM + '-' + nDD)
      userDateinput = new Date(nYYYY + '-' + nMM + '-' + nDD)
    }

    // convert user input value into date object
    var birthDate = new Date(userDateinput)

    // get difference from current date
    var difference = Date.now() - birthDate.getTime()

    var ageDate = new Date(difference)
    var calculatedAge = Math.abs(ageDate.getUTCFullYear() - 1970)

    return calculatedAge
    // alert(calculatedAge)
  },

  // สร้างเลขประจำตัวคนไข้ล่าสุด + 1 รูปแบบ "Pyymm-xxxxxx"
  genPatNo_getPrefix (corpID) {
    // YYMM-123456 : Prefix เลขที่เอกสาร คือ YYMM
    var d = new Date()
    var YY = d.getFullYear().toString().slice(2, 4) // 2023 -> 23 ; ตัดต.น. ที่ 2 ถึง 4
    var MM = ''
    if (d.getMonth() + 1 < 10) {
      MM = '0' + (d.getMonth() + 1).toString()
    } else {
      MM = (d.getMonth() + 1).toString()
    }
    var prefix = 'P' + YY + MM
    return prefix
  },
  genPatNo_New (prefix, lastPatNo) {
    let NewPatNo = ''
    let NewRunNo = ''
    if (lastPatNo === null || lastPatNo === '') {
      NewPatNo = prefix + '-000001'
    } else {
      NewRunNo = (parseInt(lastPatNo.slice(6)) + 1).toString()
      console.log('AFTER getLastPatNO')
      console.log(NewRunNo)
      NewRunNo = '0'.repeat(6 - NewRunNo.length) + NewRunNo

      NewPatNo = prefix + '-' + NewRunNo
    }
    return NewPatNo
  }
}
